import { useState } from "react";
import { TimeSeriesChart } from "../../../components/graphs/TimeSeriesChart";
import { GrainSelector } from "../../../components/graphs/ChartControls";
import { CATEGORICAL } from "../../../config/vizPalette";
import { Card, InsightSection, QueryState } from "./InsightSection";
import { useActivitySeries, useInsightMetrics } from "./useSteamInsights";

const count = (value) => (value == null ? "–" : Math.round(value).toLocaleString("en-GB"));

export const ActivityChart = () => {
    const registry = useInsightMetrics();
    const [grain, setGrain] = useState("month");
    const query = useActivitySeries(grain);

    return (
        <InsightSection
            id="activity"
            title="Games and unlocks"
            intro="How many achievements you unlocked in each period, against the running count of games started and finished."
        >
            <Card>
                <div className="mb-4 flex justify-start sm:justify-end">
                    <GrainSelector grains={registry.data?.grains} value={grain} onChange={setGrain} />
                </div>
                <QueryState query={query} isEmpty={!query.data?.series?.length} emptyText="No activity yet.">
                    <TimeSeriesChart
                        data={query.data?.series || []}
                        grain={grain}
                        series={[
                            {
                                key: "unlocks",
                                label: "Unlocks in period",
                                type: "bar",
                                axis: "left",
                                colour: CATEGORICAL[1],
                                format: count,
                            },
                            {
                                key: "cum_games_started",
                                label: "Games started",
                                type: "line",
                                axis: "right",
                                colour: CATEGORICAL[0],
                                format: count,
                            },
                            {
                                key: "cum_games_completed",
                                label: "Games completed",
                                type: "line",
                                axis: "right",
                                colour: CATEGORICAL[2],
                                format: count,
                            },
                        ]}
                        yLeft={{ label: "Unlocks", format: count }}
                        yRight={{ label: "Games", format: count }}
                        ariaLabel={`Achievement unlocks and games started by ${grain}`}
                    />
                </QueryState>
            </Card>
        </InsightSection>
    );
};
